<h2 mat-dialog-title>{{ data.titleKey | translate }}</h2>

<mat-dialog-content>
  <ng-container *ngTemplateOutlet="data.contentTemplate" />
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" class="button" mat-dialog-close>{{ 'default.ok' | translate }}</button>
</mat-dialog-actions>

